import React from "react";
import {connect} from "react-redux";
import {getSelectedDealer} from "../../selectors/customerDealer";
import DateReceptionFragment from "../../public/journey1/fragments/DateReceptionFragment";
import {getSelectedDate, getSelectedSlot, getTowing, getVin} from "../../selectors/createAppointmentRequest";
import {getMobility, getUntrustedVinwOffering} from "../../selectors/customerPreJourneyInfo";
import {getSizeClass} from "../../public/journey1/helper/uiHelper";
import moment from "moment";
import Constants from "../../services/Constants";
import {saveDateAppointment} from "../../actions/createAppointmentActions";
import {Checkbox} from "antd";
import {FormattedMessage} from "react-intl";

class DateInformation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDate: props.mySelectedDate,
      selectedSlot: props.mySelectedSlot
    };
    this.onSelectDate = this.onSelectDate.bind(this);
    this.onSelectSlot = this.onSelectSlot.bind(this);
    this.onReceptionChange = this.onReceptionChange.bind(this);
  }

  onSelectDate = selectedDate => {
    this.props.dispatchSaveDate({
      selectedDate: moment(selectedDate).format(Constants.DATE_FORMAT_API),
      selectedSlot: undefined,
    })
    this.setState({
      selectedDate: moment(selectedDate).format(Constants.DATE_FORMAT_API),
      selectedSlot: undefined,
    });
  };
  onSelectSlot = selectedSlot => {
    this.props.dispatchSaveDate({
      selectedSlot: selectedSlot
    })
    this.setState({selectedSlot});
  };
  onReceptionChange = reception => {
    this.props.dispatchSaveReception({reception})
    this.setState({reception});
  };
  setAvailabilities = availabilities => {
    this.setState({availabilities});
  };

  handleOnChange = (value) => {
    this.props.dispatchSaveTowing(value);
  }

  render() {
    const {dealer, vin, isTowing, ...props} = this.props;
    const {selectedDate, selectedSlot} = this.state;
    return (
      <React.Fragment>
        <DateReceptionFragment
          onSelectDate={this.onSelectDate}
          onSelectSlot={this.onSelectSlot}
          onReceptionChange={this.onReceptionChange}
          setAvailabilities={this.setAvailabilities}
          sizeClass={getSizeClass(window.innerWidth)}
          selectedVIN={vin}
          selectedDealer={dealer}
          {...props}
          {...this.state}
        />
        {selectedDate && selectedSlot &&
          <Checkbox style={{paddingLeft: '24px'}} checked={isTowing}
                    onChange={(e) => this.handleOnChange(e.target.checked)}><FormattedMessage id="call.center.journey.reception.towing.title"/></Checkbox>
        }
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  dealer: getSelectedDealer(state),
  vin: getVin(state),
  type: Constants.TYPE_APPOINTMENT.value,
  mobility: getMobility(state),
  isTowing: getTowing(state),
  availabilities: null,
  untrustedVinwOffering: getUntrustedVinwOffering(state),
  mySelectedDate: getSelectedDate(state),
  mySelectedSlot: getSelectedSlot(state)
});

const mapDispatchToProps = dispatch => ({
  dispatchSaveDate: (payload) => dispatch(saveDateAppointment(payload)),
  dispatchSaveReception: (params) => dispatch({type: 'SAVE.RECEPTION_APPOINTMENT', params}),
  dispatchSaveTowing: (params) => dispatch({type: 'SAVE.TOWING', params})
});

export default connect(mapStateToProps, mapDispatchToProps)(DateInformation);
